var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 463,
    viewBox: "0 0 446 463",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M442.975 342.888C442.975 354.267 395.228 364.129 325.544 368.956C296.401 370.983 263.425 372.114 228.505 372.114C193.585 372.114 160.601 370.976 131.466 368.956C61.7663 364.129 14.0273 354.267 14.0273 342.888C14.0273 331.509 61.7741 321.64 131.458 316.814C160.601 314.787 193.577 313.655 228.497 313.655C263.417 313.655 296.401 314.793 325.536 316.814C395.228 321.64 442.975 331.509 442.975 342.888Z",
    fill: "url(#paint0_linear_1759_10104)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M325.543 275.633V368.956C296.4 370.983 263.424 372.115 228.504 372.115C193.584 372.115 160.6 370.977 131.465 368.956V275.633C131.465 230.731 174.918 194.344 228.504 194.344C255.297 194.344 279.561 203.441 297.118 218.149C314.684 232.85 325.543 253.176 325.543 275.633Z",
    fill: "url(#paint1_linear_1759_10104)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M270.48 313.655C282.772 313.655 292.737 305.307 292.737 295.01C292.737 284.713 282.772 276.365 270.48 276.365C258.188 276.365 248.223 284.713 248.223 295.01C248.223 305.307 258.188 313.655 270.48 313.655Z",
    fill: "url(#paint2_radial_1759_10104)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M270.48 302.681C273.925 302.681 276.718 300.342 276.718 297.456C276.718 294.57 273.925 292.23 270.48 292.23C267.035 292.23 264.242 294.57 264.242 297.456C264.242 300.342 267.035 302.681 270.48 302.681Z",
    fill: "url(#paint3_linear_1759_10104)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M186.519 313.655C198.811 313.655 208.776 305.307 208.776 295.01C208.776 284.713 198.811 276.365 186.519 276.365C174.227 276.365 164.262 284.713 164.262 295.01C164.262 305.307 174.227 313.655 186.519 313.655Z",
    fill: "url(#paint4_radial_1759_10104)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M186.519 305.46C189.964 305.46 192.757 303.121 192.757 300.235C192.757 297.349 189.964 295.01 186.519 295.01C183.074 295.01 180.281 297.349 180.281 300.235C180.281 303.121 183.074 305.46 186.519 305.46Z",
    fill: "url(#paint5_linear_1759_10104)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 221.469,
    cy: 191.016,
    rx: 61.3639,
    ry: 59.7855,
    fill: "url(#paint6_linear_1759_10104)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M192.012 170.291L200.194 162.319L221.466 183.045L242.739 162.319L250.921 170.291L229.648 191.016L250.921 211.742L242.739 219.713L221.466 198.988L200.194 219.713L192.012 211.742L213.285 191.016L192.012 170.291Z",
    stroke: "#D2D2D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M445.383 231.027C445.383 358.361 345.776 461.555 222.942 461.555C100.107 461.555 0.5 358.361 0.5 231.027C0.5 103.694 100.107 0.5 222.942 0.5C345.776 0.5 445.383 103.694 445.383 231.027Z",
    stroke: "url(#paint7_linear_1759_10104)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M402.609 231.028C402.609 333.882 322.153 417.231 222.941 417.231C123.73 417.231 43.2734 333.882 43.2734 231.028C43.2734 128.175 123.73 44.8262 222.941 44.8262C322.153 44.8262 402.609 128.175 402.609 231.028Z",
    stroke: "url(#paint8_linear_1759_10104)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M366.317 231.027C366.317 313.11 302.109 379.62 222.942 379.62C143.774 379.62 79.5664 313.11 79.5664 231.027C79.5664 148.944 143.774 82.4336 222.942 82.4336C302.109 82.4336 366.317 148.944 366.317 231.027Z",
    stroke: "url(#paint9_linear_1759_10104)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M326.513 216.199C326.513 275.285 280.295 323.153 223.319 323.153C166.343 323.153 120.125 275.285 120.125 216.199C120.125 157.112 166.343 109.244 223.319 109.244C280.295 109.244 326.513 157.112 326.513 216.199Z",
    stroke: "url(#paint10_linear_1759_10104)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1759_10104",
    x1: 228.5,
    y1: 377.846,
    x2: 228.5,
    y2: 289.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8747,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    stopColor: "#969696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1759_10104",
    x1: 156.932,
    y1: 359.624,
    x2: 303.331,
    y2: 198.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00438596,
    stopColor: "#242934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3440"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1759_10104",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(272.77 290.409) scale(32.6921 27.3861)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3964,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5878,
    stopColor: "#E1E2E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7353,
    stopColor: "#D4D5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8603,
    stopColor: "#C2C4CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#AAAEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2A6B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1759_10104",
    x1: 264.246,
    y1: 297.456,
    x2: 276.715,
    y2: 297.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00438596,
    stopColor: "#242934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3440"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1759_10104",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.805 290.409) scale(32.6921 27.3861)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3964,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5878,
    stopColor: "#E1E2E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7353,
    stopColor: "#D4D5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8603,
    stopColor: "#C2C4CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#AAAEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2A6B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1759_10104",
    x1: 180.281,
    y1: 300.233,
    x2: 192.75,
    y2: 300.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00438596,
    stopColor: "#242934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1759_10104",
    x1: 221.469,
    y1: 104.327,
    x2: 221.469,
    y2: 260.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05B6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6D88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1759_10104",
    x1: 222.942,
    y1: 0,
    x2: 222.942,
    y2: 462.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A6D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05B6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1759_10104",
    x1: 222.941,
    y1: 44.3262,
    x2: 222.941,
    y2: 417.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A6D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05B6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1759_10104",
    x1: 222.942,
    y1: 81.9336,
    x2: 222.942,
    y2: 380.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A6D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05B6CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1759_10104",
    x1: 223.319,
    y1: 108.744,
    x2: 223.319,
    y2: 323.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A6D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05B6CA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.fc2ee9f1746d9f178c8d9c15f0720caa.svg";
export { ForwardRef as ReactComponent };